require("expose-loader?exposes=IFC!./IFC/_Public");